import Button from 'devextreme-react/button';
import {
    ArgumentAxis,
    Chart,
    CommonSeriesSettings,
    Export,
    Legend,
    Point,
    Series,
    Tooltip
} from 'devextreme-react/chart'
import LoadPanel from 'devextreme-react/load-panel';
import notify from 'devextreme/ui/notify';
import React, {useEffect, useState} from 'react';
import {getCurrentPeriod, getPointsTreePlain} from '../../api/dogovor';
import {getFileEnergosferaCounter, getOutVals, getToken, getTokenUk} from '../../api/point';
import {notifyIsueAuthFail} from '../../utils/isue-notify';
import {useAuth} from '../../contexts/auth';
import {getPoints} from '../../services/point.service';
import PopupPointsTreeHook from '../points-tree/popup-point-tree-hook';
import DateBox from "devextreme-react/date-box"
import { getFirstDayOfMounth, getLastDayOfMounth } from '../../utils/date.utils';
import {Buffer} from "buffer";
import TreeHook from "../points-tree/tree-hook";
import {useScreenSize} from "../../utils/media-query";
import Toolbar, { Item } from 'devextreme-react/toolbar';
import './reads-profile.scss'

const ReadsProfile = (props) => {
    const text = props.text
    const typeReads = props.type
    const pointsType = 'all'//'interval'

    const [points, setPoints] = useState(null)
    const [loading, setLoading] = useState(false)
    const [isPointsSelected, setIsPointsSelected] = useState(false)
    const [selectedObjects, setSelectedObjects] = useState([])
    const [btnClicked, setBtnClicked] = useState(false)
    const [pointsSource, setPointsSource] = useState([])
    const [pointsData, setPointsData] = useState([])
    const [period1, setPeriod1] = useState(new Date('01.03.2019'))
    const [period2, setPeriod2] = useState(new Date())
    const [loadingPeriod, setLoadingPeriod] = useState(false)
    const [loadingFile, setLoadingFile] = useState(false)
    const FACT_CHART_NAME = 'Максимальные часы фактической пиковой нагрузки'
    const PLAN_CHART_NAME = 'Плановые часы пиковой нагрузки'
    //const { periodEnd } = usePeriod()
    const { selectedDog : {kodDog}, selectedDog : {ndog}, selectedDog: {parameter_uk} } = useAuth()
    let { isLarge } = useScreenSize();
    const [loadingVisibleTreeHook, setloadingVisibleTreeHook] = useState(false)
    const [disabledIsue, setDisabledIsue] = useState(true)
    const isuOrIsue = process.env.REACT_APP_NAME_ENV !== 'renergy' ? "Э" : ""

    useEffect(() => {
        (async function () {
            setBtnClicked(false)
            setPointsData([])
            setPointsSource([])
            setPoints(null)
            setIsPointsSelected(false)
            setloadingVisibleTreeHook(true)
            //получаем точки по договору
            const res = await getPointsTreePlain(kodDog, pointsType)
            if (res.isOk) {
                setPoints(res.data)
            } else {
                notify(res.message, 'error', 5000)
            }
            setLoadingPeriod(true)
            const periodRes = await getCurrentPeriod(kodDog)
            if (periodRes.isOk) {
                setPeriod1(getFirstDayOfMounth(new Date(periodRes.data.period)))
                setPeriod2(getLastDayOfMounth(new Date(periodRes.data.period),false))
            }
            setLoadingPeriod(false)
            setloadingVisibleTreeHook(false)
        })()
    }, [kodDog])

    useEffect(() => {
        setPointsData([])
    },[props.type])

    const onTreeSelect = async (mas) => {
        setDisabledIsue(mas.length === 0 || (mas[0].isG && +parameter_uk !== 1))
        const points = getPoints(mas)
        setIsPointsSelected(points.length > 0)
        setSelectedObjects(mas)
        if (btnClicked) setBtnClicked(false)
        //заполним данные для графика
    }

    const onIsue = async () => {
        setLoading(true)
        if (selectedObjects.length > 0) {
            let resToken
            if (+parameter_uk !== 1) {
                if (selectedObjects[0].isG) {
                    //если головной объект берем первый после головного
                    resToken = await getToken(selectedObjects[1].id.split('_')[1])
                } else {
                    resToken = await getToken(selectedObjects[0].id.split('_')[1])
                }
            } else {
                resToken = await getTokenUk(selectedObjects[0].id.split('_')[0])
            }
            if (resToken.isOk) {
                let json = resToken.data
                if (json.hasOwnProperty('token')){
                    window.open(json.url + json.token, '_blank');
                } else {
                    notifyIsueAuthFail({message: 'Объект не содержит token'}, 'point')
                }
            } else {
                notifyIsueAuthFail(resToken, 'point')
            }
        } else notify('Не выбран объект', 'error', 3000)
        setLoading(false)
    }

    //вытаскиваем профиль
    const getOutValsInfo = async () => {
        setLoading(true)
        setBtnClicked(true)
        setPointsData([])
        setPointsSource([])

        const points = getPoints(selectedObjects)
        //console.log(selectedObjects.map(e => e.t).join(','))
        const vals = await getOutVals(points,period1,period2,typeReads, kodDog)
        if (vals.isOk) {
            let source = getPointsSource(vals.data)
            let data = vals.data
            let powerMas
            if (source.length > 0) {
                powerMas = generatePowerMas2(data, source[0])
                if (powerMas.length > 0) {
                    source.unshift({
                        value: FACT_CHART_NAME,
                        name: FACT_CHART_NAME
                    })
                    source.unshift({
                        value: PLAN_CHART_NAME,
                        name: PLAN_CHART_NAME
                    })
                }
                //console.log('source',source)
                //console.log('powerMas',powerMas)

                //for (let i=0; i<powerMas.length; i++) data.push(powerMas[i])
            }

            setPointsSource(source)
            setPointsData(powerMas)
            //console.log(data)
        } else {
            notify(vals.message,'error',5000)
        }

        setLoading(false)
    }

    function getPointsSource(mas) {
        let res = []
        let item = {}
        for (let i=0; i<mas.length; i++) {
            item = {
                value: mas[i].kod_point,
                name: 'ТУ №'+mas[i].nomer+': '+mas[i].name//selectedObjects.map(e => e.t).join(',')//
            }
            if (!res.find(el => el.value === mas[i].kod_point)) res.push(item)
        }

        return res
    }

    //берем все данные и первую точку в списке
    function generatePowerMas2(values, point) {
        let mas = []
        let maxOut = getMaxOut(values)
        if (!point || values.length === 0) return mas
        for (let val of values){
            if ((val.old_power === 4 || [3,4].includes(val.new_power)) && point.value===val.kod_point){
                if (val.old_power === 4){
                    val.value1 = FACT_CHART_NAME
                    val[FACT_CHART_NAME] = maxOut
                } else if ([3,4].includes(val.new_power)) {
                    val.value2 = PLAN_CHART_NAME
                    val[PLAN_CHART_NAME] = maxOut
                }
            }
        }
        return values
    }
    //берем все данные и первую точку в списке
    // function generatePowerMas(values, point) {
    //     let mas = []
    //     let maxOut = getMaxOut(values)
    //     if (!point || values.length === 0) return mas
    //     for (let i=0; i<values.length; i++) {
    //         let val = values[i]
    //         if (val.old_power === 4 || [3,4].includes(val.new_power)){
    //             let type = val.power_color = val.old_power === 4 ? FACT_CHART_NAME : [3,4].includes(val.new_power) ? PLAN_CHART_NAME : 'none'
    //             let item = {}
    //             item.value = type
    //             item.dat_out = val.dat_out
    //             item[type] = maxOut//val[val.kod_point]
    //             mas.push(item)
    //         }
    //     }
    //     return mas
    // }

    //определим максимаьное показание в во всем графике
    function getMaxOut(values) {
        let maxOut = null
        if (values.length === 0) return maxOut
        maxOut = values.reduce((acc, curr) => acc.out > curr.out ? acc : curr).out
        return maxOut
    }

    const calendarOptions = {
        applyValueMode: "useButtons",
        showDropDownButton: true,
    }

    async function loadFileEnergosfera() {
        setLoadingFile(true)
        const points = getPoints(selectedObjects)
        if (!pointsData){
            notify("Данные отсутствуют" , 'error', 5000)
            setLoadingFile(false)
            return
        }
        try {
            const res = await getFileEnergosferaCounter( points, period1, period2, 'EXCEL', kodDog )
            if (res.isOk) {
                const file = res.data.data
                const filename = res.data.filename
                let fileDownload = require('js-file-download')
                fileDownload(Buffer.from(file), filename)
            } else {
                notify(res.message, 'error', 5000)
            }
        } catch (e) {
            notify(e.message, 'error', 5000)
        } finally {
            setLoadingFile(false)
        }
    }

    const formatDate = (date) => {
        return new Intl.DateTimeFormat('ru-RU', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
        }).format(new Date(date))
    };
    const formatDateddMMYYY = (date) => {
        return new Intl.DateTimeFormat('ru-RU', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
        }).format(new Date(date))
    };

    const customizeExport = (data) => {
        data.fileName = `${text}-№${ndog}-${formatDateddMMYYY(period1)}-${formatDateddMMYYY(period2)}`;
    };

    return (
        <div className="row mt20 reads-profile">
            {!isLarge ?
                <div className="col-md-12">
                    <PopupPointsTreeHook
                        points={points}
                        onSelect={onTreeSelect}
                        typePoints={'all'}
                        selectionMode="multiple"
                        onShow={getOutValsInfo}
                        showDisabled={!isPointsSelected}
                    />
                </div>
                :
                <div className="col-lg-3" id='tree-hook'>
                    <LoadPanel position={{ of: '#tree-hook' }} visible={loadingVisibleTreeHook}/>
                    <TreeHook points={points} onSelect={onTreeSelect}  typePoints={'all'} selectionMode="multiple"/>
                </div>
            }
            <div id='form-container' className={(!isLarge ? "col-md-12" : "col-9") + " mt20lgx tree-hook-left"}>
                {/*<div className="row" style={{alignItems: 'baseline'}}>
                    <div className="col-xl-2 col-lg-2 col-md-3 col-sm-6 col-xs-12"  style={{minWidth: '200px'}}>
                        <DateBox
                            calendarOptions={calendarOptions}
                            openOnFieldClick={true}
                            label={'Период начала:'}
                            hint={'Период начала'}
                            labelMode={'floating'}
                            displayFormat='dd.MM.yyyy'
                            useMaskBehavior={true}
                            defaultValue={period1}
                            value={period1}
                            max={period2}
                            onValueChanged={(e) => setPeriod1(new Date(e.value))}
                            disabled={loadingPeriod}
                        />
                    </div>
                    <div className="col-xl-2 col-lg-2 col-md-3 col-sm-6 col-xs-12 mt20xs"  style={{minWidth: '200px'}}>
                        <DateBox
                            calendarOptions={calendarOptions}
                            openOnFieldClick={true}
                            displayFormat='dd.MM.yyyy'
                            useMaskBehavior={true}
                            label={'Период окончания:'}
                            hint={'Период окончания'}
                            labelMode={'floating'}
                            defaultValue={period2}
                            value={period2}
                            min={period1}
                            onValueChanged={(e) => setPeriod2(new Date(e.value))}
                            disabled={loadingPeriod}
                        />
                    </div>
                    {isLarge &&
                        <div className="col-lg-3 col-md-3 col-sm-5 col-xs-12 mt20md mt20xs" style={{minWidth: '200px'}}>
                            <Button className='w-100' disabled={!isPointsSelected} text="Показать" type='default' hint="Показать" icon="refresh" onClick={getOutValsInfo} />
                        </div>
                    }
                    <div className="col-lg-3 col-md-3 col-sm-5 col-xs-12 mt20md mt20xs"  style={{minWidth: '200px'}}>
                        <Button icon='xlsfile' className='w-100' text='Выгрузить в Excel' hint='Выгрузить в Excel' onClick={loadFileEnergosfera} disabled={!isPointsSelected}/>
                        <LoadPanel visible={loadingFile} />
                    </div>
                    {['tatenergosbyt', 'renergy'].includes(process.env.REACT_APP_NAME_ENV) &&
                        <div className="col-lg-3 col-md-4 col-sm-5 col-xs-12 mt20md mt20xs" style={{minWidth: '260px'}}>
                            <Button disabled={disabledIsue} className='w-100' text={`Данные ИСУ${isuOrIsue}`} hint="Переход в Интеллектуальную Систему Учета Электроэнергии (ИСУЭ)"
                                    icon="refresh" onClick={onIsue}/>
                        </div>
                    }
                </div>*/}
                <Toolbar>
                    <Item location="before" widget="dxButton" locateInMenu="auto" >
                        <DateBox
                            calendarOptions={calendarOptions}
                            openOnFieldClick={true}
                            label={'Период начала:'}
                            hint={'Период начала'}
                            labelMode={'floating'}
                            displayFormat='dd.MM.yyyy'
                            useMaskBehavior={true}
                            defaultValue={period1}
                            value={period1}
                            max={period2}
                            onValueChanged={(e) => setPeriod1(new Date(e.value))}
                            disabled={loadingPeriod}
                        />
                    </Item>
                    <Item location="before" widget="dxButton" locateInMenu="auto" >
                        <DateBox
                            calendarOptions={calendarOptions}
                            openOnFieldClick={true}
                            displayFormat='dd.MM.yyyy'
                            useMaskBehavior={true}
                            label={'Период окончания:'}
                            hint={'Период окончания'}
                            labelMode={'floating'}
                            defaultValue={period2}
                            value={period2}
                            min={period1}
                            onValueChanged={(e) => setPeriod2(new Date(e.value))}
                            disabled={loadingPeriod}
                        />
                    </Item>
                    <Item visible={isLarge} location="before" widget="dxButton" locateInMenu="never" >
                        <Button disabled={!isPointsSelected} text="Показать" type='default' hint="Показать" icon="refresh" onClick={getOutValsInfo} />
                    </Item>
                    <Item location="after" widget="dxButton" locateInMenu="auto" >
                        <Button icon='xlsfile' text='Выгрузить в Excel' hint='Выгрузить в Excel' onClick={loadFileEnergosfera} disabled={!isPointsSelected}/>
                        <LoadPanel visible={loadingFile} />
                    </Item>
                    <Item visible={['tatenergosbyt', 'renergy'].includes(process.env.REACT_APP_NAME_ENV)} location="after" widget="dxButton" locateInMenu="auto" >
                        <Button disabled={disabledIsue} text={`Данные ИСУ${isuOrIsue}`} hint="Переход в Интеллектуальную Систему Учета Электроэнергии (ИСУЭ)"
                                icon="refresh" onClick={onIsue}/>
                    </Item>
                </Toolbar>
                {isPointsSelected && btnClicked ?
                    <div className="row">
                        <div className="col-md-12">
                            <div>
                                <Chart
                                    id="chart"
                                    dataSource={pointsData}
                                    barGroupPadding={0}
                                    onExporting={customizeExport}
                                    height={400 + selectedObjects.length * 14}
                                    title={{
                                        text: ' ',
                                        horizontalAlignment: "left", // Выравнивание слева
                                        verticalAlignment:'bottom',
                                        font: {
                                            size: 0, // Размер шрифта 20px
                                            weight: "bold", // Жирный шрифт
                                            margin: { bottom: 0 },
                                        },
                                        // Дополнительные настройки (необязательно):
                                        margin: { bottom: 10 }, // Отступ снизу
                                        subtitle: { // Подзаголовок (если нужен)
                                            text: selectedObjects.map(e => e.t).join('\r\n'),
                                            font: { size: 12 },
                                        },
                                    }}
                                >
                                    <CommonSeriesSettings
                                        argumentField="dat_out"
                                        type="spline"
                                        ignoreEmptyPoints={true}
                                    >
                                        <Point visible={false} hoverMode="allArgumentPoints" />
                                    </CommonSeriesSettings>
                                    <ArgumentAxis
                                        argumentType="datetime"
                                        label={{
                                            format: {
                                                type: 'datetime',
                                                formatter: (date) => formatDate(date)
                                            }
                                        }}
                                    />
                                    {
                                        pointsSource.map((item) => <Series barPadding={0}
                                                                           key={item.value}
                                                                           valueField={item.value}
                                                                           name={item.name}
                                                                           color={(item.name === FACT_CHART_NAME && 'orange') || (item.name === PLAN_CHART_NAME && 'green')}
                                                                           type={[FACT_CHART_NAME, PLAN_CHART_NAME].includes(item.name) && 'bar'}
                                        />)
                                    }
                                    <Legend
                                        verticalAlignment="bottom"
                                        horizontalAlignment="center"
                                        hoverMode="excludePoints"
                                    />
                                    <Tooltip
                                        enabled={true}
                                        shared={true}
                                        customizeTooltip={customizeTooltip}
                                    />
                                    <Export
                                        enabled={true}
                                    />
                                </Chart>
                                <LoadPanel visible={loading} />
                            </div>
                        </div>
                    </div>
                    :
                    <div className='text-center-horizontal-vertical mt-4 d-none d-md-block '><strong>Выберите точки учета и нажмите «Показать»</strong></div>
                }
            </div>
        </div>
    )
}
function customizeTooltip(pointInfo) {
    const items = pointInfo.valueText.split('\n');
    const color = pointInfo.point.getColor();
    items.forEach((item, index) => {
        if (item.indexOf(pointInfo.seriesName) === 0) {
            const element = document.createElement('span');
            element.textContent = item;
            element.style.color = color;
            element.className = 'active';
            items[index] = element.outerHTML;
        }
    });

    return { text: items.join('\n') };
}
export default ReadsProfile
